import React from "react";
import { Phone, Mail, MapPin, Globe } from "lucide-react";
import { SITE, NAV_LINKS } from "@/lib/site-data";
import { BrandMark } from "@/components/BrandMark";

export const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F1F15] text-white pt-20 pb-10 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 pb-12 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <BrandMark className="w-12 h-12" dotRing="#0F1F15" />
              <div className="leading-tight">
                <div className="font-['Outfit'] font-black text-xl tracking-tight">
                  Imperial Landscaping, TLH
                </div>
                <div className="text-[10px] tracking-[0.28em] uppercase text-white/55 font-semibold">
                  {SITE.region}
                </div>
              </div>
            </div>
            <p className="text-base text-white/70 leading-relaxed max-w-md">
              {SITE.tagline} Family-run, locally trusted, and ready to make your
              property the best-looking one on the block.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#EAB308] font-bold mb-4">
              Explore
            </div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="text-white/80 hover:text-[#EAB308] font-medium transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#EAB308] font-bold mb-4">
              Get in touch
            </div>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#EAB308]" />
                <a
                  href={`tel:${SITE.phoneTel}`}
                  data-testid="footer-phone"
                  className="font-bold hover:text-[#EAB308] transition-colors"
                >
                  {SITE.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#EAB308]" />
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email"
                  className="hover:text-[#EAB308] transition-colors"
                >
                  {SITE.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-[#EAB308]" />
                <span className="text-white/80">{SITE.region}</span>
              </li>
              <li className="flex items-center gap-3">
                <Globe className="w-4 h-4 text-[#EAB308]" />
                <span className="text-white/80">{SITE.website}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col md:flex-row gap-4 items-center justify-between text-sm text-white/55">
          <div>
            © {new Date().getFullYear()} Imperial Landscaping, TLH. All rights
            reserved.
          </div>
          <div className="flex items-center gap-6">
            <span className="font-medium">Tallahassee · Killearn · Midtown · Betton Hills · Southwood</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
